import axiosClient from "./axiosClient";

const KNOWN_STATUSES = new Set(["available", "exhausted", "unknown"]);
const KNOWN_SCOPES = new Set(["business", "waba", "unknown"]);

const nullableNonNegativeInteger = value =>
  Number.isInteger(value) && value >= 0 ? value : null;

export function normalizeAdditionalNumberPreflight(payload) {
  const rawStatus = String(payload?.status || "").toLowerCase();
  const rawScope = String(payload?.scope || "").toLowerCase();

  return {
    status: KNOWN_STATUSES.has(rawStatus) ? rawStatus : "unknown",
    used: nullableNonNegativeInteger(payload?.used),
    maximum: nullableNonNegativeInteger(payload?.maximum),
    remaining: nullableNonNegativeInteger(payload?.remaining),
    scope: KNOWN_SCOPES.has(rawScope) ? rawScope : "unknown",
    checkedAtUtc: payload?.checkedAtUtc || null,
    reasonCode: typeof payload?.reasonCode === "string" ? payload.reasonCode : "",
  };
}

export async function getAdditionalNumberPreflight() {
  const { data } = await axiosClient.get(
    "/whatsappsettings/additional-number-preflight",
  );
  return normalizeAdditionalNumberPreflight(data);
}

export function hasReliableCapacityUsage(preflight) {
  return (
    (preflight?.status === "available" || preflight?.status === "exhausted") &&
    (preflight?.scope === "business" || preflight?.scope === "waba") &&
    Number.isInteger(preflight?.used) &&
    Number.isInteger(preflight?.maximum)
  );
}
